module.exports = __webpack_public_path__ + "images/花筑村全景_06-6.jpg?v=63ac7550";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_06-6.jpg
 ** module id = 98
 ** module chunks = 1 2
 **/